import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import type { Product } from '~/api/products/types';

import { Button, Menu } from '~/components';
import { optionsMenuTriggerStyle } from '~/components/Table/TableRow.css';
import { bypassBlocker } from '~/constants/router';
import { SearchParamKeys, SearchParamModals } from '~/constants/url';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { persistFormDataInSession } from '~/utils/form';
import { qs } from '~/utils/searchParams';

import { useFormWithLinesContext } from '../../FormLines.context';

type Props = {
  product: Product;
};

export const ProductPickerOptionsCell = ({ product }: Props) => {
  const { getValues } = useFormWithLinesContext();

  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  const navigateToEditProduct = () => {
    persistFormDataInSession(window.location.pathname, getValues());

    navigate(
      {
        pathname: r(routes.editProduct, { productId: product.id }),
        search: qs({
          [SearchParamKeys.REDIRECT_PATH]: location.pathname,
          [SearchParamKeys.REDIRECT_MODAL]: SearchParamModals.ADD_PRODUCT,
        }),
      },
      { state: bypassBlocker },
    );
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Menu.Root>
        <Menu.Trigger render={<Button aria-label={t('common:actions.openMenu')} className={optionsMenuTriggerStyle} icon="MoreVert" />} />

        <Menu.List>
          <Menu.Item icon="Edit" onClick={navigateToEditProduct}>
            {t('common:actions.edit')}
          </Menu.Item>
        </Menu.List>
      </Menu.Root>
    </div>
  );
};
